import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Alert, FormFeedback, Input, Label, Button, Spinner } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunks";

import ParticlesAuth from "./ParticlesAuth";
import { createSelector } from "reselect";

const ForgetPasswordPage = (props: any) => {
  const dispatch: any = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Email không hợp lệ").required("Vui lòng nhập email"),
    }),
    onSubmit: (values) => {
      setSubmitting(true);
      dispatch(userForgetPassword(values));
    }
  });

  const selectLayoutState = (state: any) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state: any) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (forgetError || forgetSuccessMsg) {
      setSubmitting(false);
    }
  }, [forgetError, forgetSuccessMsg]);

  document.title = "Hệ thống quản lý đặt món - Quên mật khẩu";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-10 col-lg-8">
              <div className="text-center">
                <h2 className="text-white">Quên mật khẩu</h2>
                <p className="text-white-50">Nhập email để nhận hướng dẫn đặt lại mật khẩu.</p>
              </div>
              <div className="register-form mt-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {forgetError && (<Alert color="danger">{forgetError}</Alert>)}
                  {forgetSuccessMsg && (<Alert color="success">{forgetSuccessMsg}</Alert>)}
                  <div className="form-group text-start mb-4">
                    <span>Địa chỉ Email</span>
                    <Label>
                      <i className="mdi mdi-email-outline"></i>
                    </Label>
                    <Input
                      name="email"
                      className="form-control"
                      placeholder="email@example.com"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={validation.touched.email && validation.errors.email ? true : false}
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                    ) : null}
                  </div>
                  <Button
                    className="btn btn-warning btn-lg w-100"
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting && <Spinner size="sm" className='me-2'></Spinner>}
                    Gửi liên kết đặt lại mật khẩu
                  </Button>
                </form>
              </div>
              <div className="login-meta-data">
                <p className="mb-0 text-white">
                  <Link to="/login" className="text-warning">Quay lại đăng nhập</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  router: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
